"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchActiveLoyaltyProvider = exports.resolveActiveLoyaltyProvider = exports.isProviderActive = exports.GROWTH_LOYALTY_PROVIDER = void 0;
const api_1 = require("../api");
const models_1 = require("../models");
exports.GROWTH_LOYALTY_PROVIDER = models_1.ExternalLoyaltyProviders.BLAZE_GROWTH;
const NON_EXTERNAL_LOYALTY_PROVIDERS = new Set([
    models_1.ExternalLoyaltyProviders.GREENLINE,
]);
const INTERNAL_ONLY = {
    provider: null,
    config: null,
};
const isProviderActive = (configs, provider) => configs.some((config) => config.loyaltyProviderEnabled && config.loyaltyProvider === provider);
exports.isProviderActive = isProviderActive;
/** A merchant runs a single provider, so the first enabled non-internal entry wins. */
const resolveActiveLoyaltyProvider = (configs) => {
    var _a;
    const enabled = configs.find((config) => config.loyaltyProviderEnabled && !NON_EXTERNAL_LOYALTY_PROVIDERS.has(config.loyaltyProvider));
    return {
        provider: (_a = enabled === null || enabled === void 0 ? void 0 : enabled.loyaltyProvider) !== null && _a !== void 0 ? _a : null,
        config: enabled !== null && enabled !== void 0 ? enabled : null,
    };
};
exports.resolveActiveLoyaltyProvider = resolveActiveLoyaltyProvider;
/**
 * Degrades to internally managed loyalty when the gateway cannot be reached: callers
 * await this before unrelated work, and a rejection here has blanked entire pages.
 */
const fetchActiveLoyaltyProvider = (context) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const configs = yield (0, api_1.getExternalLoyaltyConfigs)({
            gatewayUrl: context.getGatewayUrl(),
            merchantId: context.getMerchantId(),
        });
        return (0, exports.resolveActiveLoyaltyProvider)(configs);
    }
    catch (error) {
        return INTERNAL_ONLY;
    }
});
exports.fetchActiveLoyaltyProvider = fetchActiveLoyaltyProvider;
//# sourceMappingURL=resolve.js.map